import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './MobileAuthorizationManagementPage.css';

const ChevronRight = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#bbb" strokeWidth="2">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

const intro =
  'Manage what this app is allowed to access on your device and what data you have authorized for your account. Some controls may open your system settings.';

const rows = [
  {
    title: 'App permissions',
    detail: 'Camera, photos, notifications, and other device permissions are managed in your system settings for this app.',
    action: 'Open in settings'
  },
  {
    title: 'Account & sign-in',
    detail: 'Email, phone, and social sign-in methods linked to your account. Remove or add methods from your profile and security settings.',
    action: 'View profile'
  },
  {
    title: 'Data & third parties',
    detail: 'Authorizations you have given for analytics, marketing, and partner integrations. You can withdraw consent where applicable.',
    action: 'Learn more'
  }
];

export default function MobileAuthorizationManagementPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  const onRow = (i) => {
    if (i === 0) {
      if (typeof window !== 'undefined' && /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
        window.alert('Open your device Settings → Apps → this app to manage camera, storage, and other permissions.');
      } else {
        window.alert('Browser: use your browser or OS site settings to control permissions for this site.');
      }
      return;
    }
    if (i === 1) {
      if (isAuthenticated) {
        navigate('/mobile/profile');
      } else {
        navigate('/', { state: { from: location, showLogin: true }, replace: false });
      }
      return;
    }
    navigate('/mobile/notification-settings');
  };

  return (
    <div className="mauth-page">
      <header className="mauth-header">
        <button type="button" className="mauth-back" onClick={() => navigate(-1)} aria-label="Back">
          <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2.2">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <h1 className="mauth-title">Authorization management</h1>
      </header>
      <div className="mauth-scroll">
        <section className="mauth-intro">
          <p className="mauth-intro-p">{intro}</p>
        </section>
        {rows.map((r, i) => (
          <button key={r.title} type="button" className="mauth-row" onClick={() => onRow(i)}>
            <div className="mauth-row-inner">
              <div className="mauth-row-text">
                <h2 className="mauth-h2">{r.title}</h2>
                <p className="mauth-d">{r.detail}</p>
                <span className="mauth-cta">{r.action}</span>
              </div>
              <ChevronRight />
            </div>
          </button>
        ))}
        <p className="mauth-foot">
          If you revoke permissions, some features (such as image upload or push alerts) may stop working until you allow
          them again.
        </p>
      </div>
    </div>
  );
}
